// ログイン中の会員を Clarity のユーザーとして紐付ける。
// 録画フィルター「カスタムユーザー ID」で会員ごとのセッションを確認できる。
// Clarity は identify をページごとに呼ぶ必要があるため、ページ遷移のたびに呼ぶ。

export const identifyClarityUser = (account) => {
  if (!account || typeof window.clarity !== "function") return;

  const email = account.idTokenClaims?.emails?.[0];
  const friendlyName = [account.name, email].filter(Boolean).join(" ");
  window.clarity(
    "identify",
    account.localAccountId,
    undefined,
    undefined,
    friendlyName || undefined,
  );
};
